<script lang="ts" setup>
	import CheckIcon from './CheckIcon.vue'

	interface Props {
		name: string
		icon: string
		selected?: boolean
	}

	withDefaults(defineProps<Props>(), {
		selected: false,
	})

	const emit = defineEmits<{
		select: []
	}>()
</script>

<template>
	<div
		:class="[
			'relative rounded-xl border-2 p-3 lg:p-4 cursor-pointer transition-all duration-300',
			selected ?
				'border-[#021F58] bg-[#021F58]/5 shadow-lg'
			:	'border-gray-200 hover:border-[#021F58]/30 hover:shadow-md',
		]"
		@click="emit('select')"
	>
		<div
			class="flex flex-col sm:flex-row sm:items-center text-center sm:text-left space-y-2 sm:space-y-0 sm:space-x-3"
		>
			<div
				:class="[
					'w-10 h-10 lg:w-12 lg:h-12 rounded-full flex items-center justify-center mx-auto sm:mx-0',
					selected ? 'bg-[#021F58]/10' : 'bg-gray-100',
				]"
			>
				<span
					:class="[
						'material-symbols-outlined text-xl lg:text-2xl',
						selected ? 'text-[#021F58]' : 'text-gray-600',
					]"
				>
					{{ icon }}
				</span>
			</div>
			<p
				:class="[
					'font-inter font-medium text-sm lg:text-base',
					selected ? 'text-[#021F58]' : 'text-gray-700',
				]"
			>
				{{ name }}
			</p>
		</div>

		<!-- Check icon -->
		<div
			v-if="selected"
			class="absolute -top-2 -right-2"
		>
			<CheckIcon
				size="md"
				color="blue"
			/>
		</div>
	</div>
</template>
